<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <h2 class="text-xs-center">{{title}} <span class="timer">{{timer.left}}</span></h2>
    <div class="text-xs-center pagination">
      <v-pagination :length="questions.length" v-model="currentQuestion" @input="showQuestion"/>
    </div>
    <form @submit.prevent="endTestStage">
      <v-card class="question">
        <v-card-text v-show="question.display" v-for="(question, index) in questions" :key="index">
          <h3>{{(index + 1) + '. ' + question.text}}</h3>
          <v-radio-group @change="saveAnswer(question.id)" v-model="answersForSend[question.id].answerId">
            <v-radio :total-visible="question.answers.length" v-for="(answer, aindex) in question.answers" :key="aindex"
                     :label="answer.text" :value="answer.id" :class="radioAnswer(question.id, answer.id)"/>
          </v-radio-group>
        </v-card-text>
        <div class="buttons">
          <v-btn color="success" :disabled="currentQuestion === questions.length" @click="toNext">Далее</v-btn>
          <v-btn flat :disabled="currentQuestion === 1" @click="toPrev">Назад</v-btn>
        </div>
      </v-card>
      <v-btn type="submit" class="mt-3 mx-auto d-block" color="success"
             :disabled="canEnd">
        Закончить тестирование и перейти к следующему этапу
      </v-btn>
    </form>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="360">
        <v-card>
          <v-card-title class="headline">Время тестирования вышло</v-card-title>
          <v-card-text>Отмеченные ответы будут сохранены</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="endTestStage">Ок</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import AttestationService from '@/services/AttestationService'
import SettingsService from '@/services/SettingsService'

export default {
  data: () => ({
    title: 'Тестирование',
    questions: [],
    answersForSend: {},
    currentQuestion: 1,
    prevQuestion: 1,
    timer: {leftInt: 2400, left: '40:00'},
    interval: null,
    answeredPaginationItems: [],
    dialog: false,
    attestationService: undefined
  }),
  computed: {
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    },
    canEnd () {
      for (let item in this.answersForSend) {
        if (this.answersForSend[item].answerId === undefined) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    initPagination () {
      this.$el.querySelectorAll('.pagination li button').forEach(btn => {
        if (this.answeredPaginationItems.indexOf(btn.textContent) > -1) {
          btn.classList.add('answered')
        } else {
          btn.classList.remove('answered')
        }
      })
    },
    showQuestion () {
      setTimeout(function (context) {
        context.initPagination()
      }, 100, this)
      this.questions[this.prevQuestion - 1].display = false
      this.questions[this.currentQuestion - 1].display = true
      this.prevQuestion = this.currentQuestion
    },
    toPrev () {
      this.currentQuestion--
      this.showQuestion()
    },
    toNext () {
      this.currentQuestion++
      this.showQuestion()
    },
    endTestStage () {
      this.attestationService.endTestStage((data) => {
        if (data.status) {
          this.$router.push('/attestation/thematic')
          clearInterval(this.interval)
        }
      })
    },
    radioAnswer (questionId, answerId) {
      if (this.answersForSend[questionId].answerId !== undefined &&
        this.answersForSend[questionId].rightAnswerId === answerId) {
        return 'green-back-answer'
      }
      if (this.answersForSend[questionId].rightAnswerId !== undefined &&
        this.answersForSend[questionId].answerId === answerId &&
        this.answersForSend[questionId].rightAnswerId !== answerId) {
        return 'red-back-answer'
      }
      return ''
    },
    saveAnswer (questionId) {
      this.answeredPaginationItems.push(this.currentQuestion.toString())
      let answerId = this.answersForSend[questionId].answerId
      this.attestationService.saveTestAnswer(questionId, answerId, (data) => {
      })
    },
    compareId (questionA, questionB) {
      return questionA.id - questionB.id
    }
  },
  created () {
    this.attestationService = new AttestationService(this.$store)
    this.attestationService.getStudentAttestationInfo((data) => {
      if (data.info.testStageEnded) {
        this.$router.push('/attestation/thematic')
      } else {
        this.timer.leftInt = data.info.testTimeLeft
        this.attestationService.getTestQuestions((list) => {
          let questions = []
          let answers = {}
          let index = 1
          list.forEach(activeQuestion => {
            activeQuestion.question.display = false
            if (activeQuestion.question.needFixAnswers) {
              activeQuestion.question.answers.sort(this.compareId)
            }
            questions.push(activeQuestion.question)
            if (activeQuestion.answer) {
              answers[activeQuestion.question.id] = {answerId: activeQuestion.answer}
              this.answeredPaginationItems.push(index.toString())
            } else {
              answers[activeQuestion.question.id] = {answerId: undefined}
            }
            index++
            if (activeQuestion.question.rightAnswer) {
              answers[activeQuestion.question.id].rightAnswerId = activeQuestion.question.rightAnswer.id
            }
          })
          this.answersForSend = answers
          this.questions = questions
          this.showQuestion()
          this.interval = setInterval(function (context, timer) {
            let dateEnd = new Date(context.timer.leftInt * 1000)
            let mm = dateEnd.getMinutes()
            if (mm < 10) mm = '0' + mm
            let ss = dateEnd.getSeconds()
            if (ss < 10) ss = '0' + ss
            timer.left = mm + ':' + ss
            if (context.timer.leftInt <= 0) {
              clearInterval(context.interval)
              context.dialog = true
              return
            }
            context.timer.leftInt--
            context.attestationService.setTime(context.timer.leftInt)
          }, 1000, this, this.timer)
        })
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.interval)
    next()
  }
}
</script>

<style lang="scss" scoped>
h2 {
  position: relative;

  .timer {
    position: absolute;
    right: 0;
  }
}

.question {
  margin-top: 20px;

  /deep/ label {
    color: rgba(0, 0, 0, 0.8) !important;
  }

  .buttons {
    margin-top: -20px;
    padding: 0 10px 10px;
    display: flex;
    justify-content: space-between;
  }
}

.green-back-answer {
  border-radius: 8px;
  background: rgba(0, 255, 0, 0.05);
}

.red-back-answer {
  border-radius: 8px;
  background: rgba(255, 0, 0, 0.05);
}

.pagination {
  /deep/ .answered {
    background: #757575 !important;
    color: #fff !important;
  }

  /deep/ .v-pagination__item {
    transition-duration: 0.0s;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/student/attestation/Test.vue